import {
  Button,
  Tag,
  Popconfirm,
} from "antd"
import { DeleteTwoTone } from "@ant-design/icons"

export const renderFloorNumber = params => {
  if (params.floorNumber == 0 && params.unitNumber == 1)
    return <small>همکف</small>
  if (params.floorNumber == 0 && params.unitNumber > 1)
    return <small>چند واحدی</small>
  return params.floorNumber
}

export const renderRowNumber = (index, { pageIndex, pageSize }) => {
  return (pageIndex - 1) * pageSize + index + 1
}

export const renderDeleteButton = (params, { props, handleDelete }) => {
  return params.projectLevel === 4 ||
    params.projectLevel === 5 ||
    params.projectLevel === 7 ||
    (params.projectLevel === 3 && params.inspectionStatus == 0) ? (
    <Popconfirm
      title="حذف تخصیص"
      description="مطمئنی یا نه؟"
      onConfirm={() => handleDelete(params)}
      okText="Yes"
      cancelText="No"
    >
      {" "}
      <Button icon={<DeleteTwoTone />} />{" "}
    </Popconfirm>
  ) : (
    "-"
  )
}
export const projectColumnsAnt = props =>
  [
    //index row
    // {
    //   title: "#",
    //   key: "id",
    //   render: (id, record, index)=> renderRowNumber(index, props),
    //   width: "3rem",
    // },
    {
      title: "حذف",
      key: "delete",
      render: params => renderDeleteButton(params, props),
      width: "3rem",
    },
    {
      title: "شماره پرونده",
      key: "fileNumber",
      render: params => (
        <div className="d-flex flex-column gap-2 justify-content-center align-items-center">
          <Tag>{params.fileNumber}</Tag>
          <Tag>{params.landLordName}</Tag>
        </div>
      ),
      width: "8rem",
    },
    {
      title: "تاریخ تخصیص",
      key: "solarDateDeliverEngineer",
      render: params => (
        <div className="d-flex flex-column gap-2 justify-content-center align-items-center">
          <Tag>{params.solarDateDeliverEngineer}</Tag>
          <Tag>
            {params.solarDateDeliverOffice
              ? params.solarDateDeliverOffice
              : "ندارد"}
          </Tag>
        </div>
      ),
      width: "7rem",
    },
    {
      title: "واحد",
      key: "unitNumber",
      render: params => (
        <div className="d-flex flex-column gap-2 justify-content-center align-items-center">
          <Tag>{params.unitNumber}</Tag>
          <Tag>{renderFloorNumber(params)}</Tag>
        </div>
      ),
      width: "3rem",
    },
    {
      title: "کارشناس",
      key: "enName",
      dataIndex: "enName",
      width: "6rem",
    },
    {
      title: "مجری",
      key: "executorName",
      render: params => (
        <div className="d-flex flex-column gap-2 justify-content-center align-items-center">
          <Tag>{params.executorName}</Tag>
          <Tag>{params.executorCellPhone}</Tag>
        </div>
      ),
      width: "7rem",
    },
    // {
    //   title: "شهر",
    //   key: "section",
    //   render: row => {
    //     let returnValue = "-"
    //     if (row.idSection > 0) {
    //       returnValue = GetCityWithSection(row.idSection)
    //     }
    //     return returnValue
    //   },
    //   width: "7rem",
    // },
    {
      title: "نوع بازرسی",
      key: "inspectionTypeName",
      render: params => (
        <div className="d-flex flex-column gap-2 justify-content-center align-items-center">
          <Tag>{params.inspectionTypeName}</Tag>
          <Tag>{params.projectLevelName}</Tag>
        </div>
      ),
      width: "7rem",
    },
    {
      title: "سایز کنتور",
      key: "inspectionParameterTypeName",
      render: params => (
        <div className="d-flex flex-column gap-2 justify-content-center align-items-center">
            <Tag color={params.pipingTypeName === "روکار" ? "" : "yellow"}>
            {params.pipingTypeName}
          </Tag>
          <Tag
            color={
              params.buildingTypeName === "تجاری"
                ? "cyan"
                : params.buildingTypeName === "صنعتی"
                ? "orange"
                : ""
            }
          >
            {params.buildingTypeName}
          </Tag>
          <Tag>{params.inspectionParameterTypeName}</Tag>

        </div>
      ),
      width: "5rem",
    },
    {
      title: "آدرس",
      key: "address",
      render: params => {
        return params.gasProject.address
      },
      width: "10rem",
    },
    {
      title: "تاریخ تایید",
      key: "solarDateDeliverOffice",
      dataIndex: "solarDateDeliverOffice",
      width: "5rem",
      hidden: params => props.matches_sm || params.projectLevel === 4,
    },
    {
      title: "وضعیت",
      key: "inspectionStatus",
      render: record => (
        <Tag color={record.inspectionStatus === 1 ? "green" : "red"}>
          {record.inspectionStatusName}
          {record.defect ? "+نقص" : ""}
        </Tag>
      ),
      width: "6rem",
    },
  ].filter(item => !item.hidden)
